
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const currentPath = window.location.pathname;

    console.log("status",status)

    if (status === 401 && currentPath !== "/") {
      localStorage.clear();
      sessionStorage.clear();

      window.location.replace("/"); // replace avoids history spam
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
